module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.value) + " "), (_vm.help_text_url) ? _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7723014"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/label.vue
// module id = 1055
// module chunks = 0